export { default } from './FunnelChart.js';
